

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';
import { EnumPaymentRequestTypes } from './../enums';
import { EnumDeliveryMethods } from './../enums';
import { EnumPaymentRequestStatuses } from './../enums';
import { EnumPaymentRequestSteps } from './../enums';
import { DocumentLine } from './../entities/documentline.entity';
export class PaymentRequest extends BaseEntity
{   
    public CustomerID: number; //READ ONLY (BlockWrite)
    public ContactPersonID: number; //READ ONLY (BlockWrite)
    public CompanyID: number; //READ ONLY (BlockWrite)
    public Url: string; 
    public TotalSum: number; 
    public Type: EnumPaymentRequestTypes; //READ ONLY (BlockWrite)
    public NumberOfPayments: number; 
    public EmailForReceipt: string; 
    public DeliveryMethod: EnumDeliveryMethods; 
    public InvoiceDocumentNumber: number; //READ ONLY (BlockWrite)
    public ReceiptDocumentNumber: number; //READ ONLY (BlockWrite)
    public OrderDocumentNumber: number; //READ ONLY (BlockWrite)
    public Status: EnumPaymentRequestStatuses; //READ ONLY (BlockWrite)
    public Currency: string; //READ ONLY (BlockWrite)
    public Created: Date; 
    public CustomerDisplayText: string; 
    public ContactPersonName: string; 
    public Sum: number; 
    public BaseTypeString: string; 
    public BaseNumber: number; 
    public Lines: PaymentRequestLine[] = []; 
    public CreditCardNumber: string; 
	public CreatedBy: number;
	public CreatedDate: Date;
}

export class PaymentRequestLine extends BaseEntity
{   
    public LedgerID: number; 
    public OrderID: number; 
    public PriceProposalID: number; 
    public DeliveryID: number; 
    public LineID: number;
}
export class PaymentRequestStep extends BaseEntity
{   
    public Step: EnumPaymentRequestSteps; 
    public IsSuccess: boolean; 
    public Comment: string; 
    public LineID: number;
}
export class PaymentRequestDocumentLine extends BaseEntity
{   
    public DocumentType: number; 
    public SBODocumentEntry: number; 
    public DocumentLine: DocumentLine = new DocumentLine; 
    public LineID: number;
}


